import { render, staticRenderFns } from "./ChangeStatus-comp.vue?vue&type=template&id=2235bac1&scoped=true&"
import script from "./ChangeStatus-comp.vue?vue&type=script&lang=js&"
export * from "./ChangeStatus-comp.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatus-comp.vue?vue&type=style&index=0&id=2235bac1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2235bac1",
  null
  
)

export default component.exports